import { Button, Divider, Input, InputRef, Modal, Select, Space, Spin, Tabs, TabsProps, Tooltip } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { allCommonImages } from "../Assets/Images/images";
import React, { ReactNode, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { svg } from "../Assets/svg";
import { alias, BACKEND_DOMAIN } from "../helpers/utils";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Close from "../Assets/Images/Icons/Close.svg";
import { UserI } from "../Admin/Types/state/user.state";
import { Swiper as SwiperClass } from "swiper";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import { NavLink } from "react-router-dom";
import { Field } from "formik";
import Table, { ColumnsType } from "antd/es/table";
import moment from "moment";
const Logo = allCommonImages.LogoWhite;
// Site Loader
interface SiteLoaderProps {
  text?: string;
}
export const SiteLoader: React.FC<SiteLoaderProps> = ({ text }) => {
  const { pathname } = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 300); // Ensuring smooth transition
    return () => clearTimeout(timer);
  }, []);
  if (pathname === "/") {
    return null;
  }

  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        textAlign: "center",
        width: "calc(100% - 1rem)",
      }}
    >
      <div className="Loader">
        <div className="d-block">
          <div className="spinner-border" role="status"></div>
        </div>
      </div>
      <p className="ff" style={{ fontSize: "1rem", lineHeight: "1.1" }}>
        {text !== undefined ? text : "Please wait a moment while we arrange some things"}
      </p>
    </div>
  );
};

export const BtnLoader: React.FC<any> = ({ color = "#fff" }) => {
  return (
    <Spin
      indicator={
        <LoadingOutlined
          style={{
            fontSize: 16,
            color: color ? color : "#fff",
          }}
          spin
          className="me-2"
        />
      }
    />
  );
};

interface NavigationBarProps {
  menuOpen: boolean;
  setMenuOpen: (value: boolean) => void;
  navigationData: any;
}

export const NavigationBar: React.FC<NavigationBarProps> = ({ navigationData, menuOpen, setMenuOpen }) => {
  const [toggleActive, setToggleActive] = useState(true);
  const [accountClass, setAccountClass] = useState(true);
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const dropDownRef = useRef<HTMLDivElement>(null); // Correct reference
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClickOutside = (e: MouseEvent) => {
    // Use the correct variable name
    if (dropDownRef.current && !dropDownRef.current.contains(e.target as Node)) {
      setAccountClass(true);
    }
  };

  const toggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen);
    setMenuOpen(!menuOpen);
  };

  return (
    <div className="NavigationBar customNavigation position-fixed overflow-hidden c-white pt-0">
      <div className="d-flex flex-column h-100">
        <div className="flex-fill overflow-y-auto pb-3">
          <a className="d-inline-block" onClick={() => navigate("/dashboard")}>
            <img
              src={Logo} // Replace with actual logo path
              width={169}
              height={99}
              className="img-fluid mb-navbar-logo object-fit-contain"
              alt="Logo"
            />
          </a>
          {navigationData?.map((elem: any) => {
            return (
              <NavLink
                to={elem?.path}
                className="NavigationLink d-flex px-3 position-relative text-decoration-none"
                data-image={elem?.label}
                onClick={elem?.handleClick}
              >
                <div className="NavIconBG">{elem?.icon}</div>
                <div
                  className={`labelContainer ${
                    elem?.length ? "d-flex align-items-center justify-content-between w-100" : ""
                  }`}
                >
                  <span>{elem?.label}</span>
                  {elem?.length && elem?.length}
                </div>
              </NavLink>
            );
          })}
          <div className={`menu-animate-btn position-relative ${menuOpen ? "menu-open" : ""}`} onClick={toggleNavbar}>
            <span className="d-block position-absolute top-50 start-0 translate-middle-y"></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const TableLoader = () => {
  return (
    <div className="loader-container py-5">
      <div className="loader">
        <div className="spinner-border" role="status"></div>
      </div>
    </div>
  );
};

export function prefixZero(e: number) {
  return Number(e) < 10 ? `${e}` : String(e);
}
interface CustomPaginationProps {
  pageId: number;
  countCalculation: number;
  setPageId: (page: number) => void;
  className: string;
  pageCount: number;
  listCount: number;
  limit: number;
  deletedData?: () => any;
}
export const CustomPagination: React.FC<CustomPaginationProps> = ({
  pageId,
  countCalculation,
  setPageId,
  className,
  pageCount,
  listCount,
  limit,
  deletedData,
}) => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pageId]);

  // Handler
  const nextPageHandler = () => {
    if (countCalculation > pageId) setPageId(pageId + 1);
  };

  const prevPageHandler = () => {
    if (pageId > 0) setPageId(pageId - 1);
  };
  const generatePageNumbers = () => {
    const pages = [];
    const startPage = Math.max(pageId - 2, 1);
    const endPage = Math.min(pageId + 2, Math.ceil(pageCount / limit));

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const pageNumbers = generatePageNumbers();

  return (
    <div className={`${className} d-flex flex-wrap align-items-center justify-content-between pagination__container`}>
      <div className="">{`${pageId * limit - limit + 1} - ${
        limit * pageId > countCalculation ? countCalculation : limit * pageId
      }  out of ${countCalculation}`}</div>
      {deletedData && deletedData()}
      <nav>
        <ul className="pagination mb-0 gap-2">
          <li className={`page-item ${pageId === 1 ? "disabled" : ""}`}>
            <button className="page-link" onClick={prevPageHandler} disabled={pageId === 1}>
              {svg.pagePreview}
            </button>
          </li>
          {pageNumbers.map((page) => (
            <li className="page-item">
              {/* <button className="page-link">{prefixZero(pageId)}</button> */}
              <a className={pageId === page ? "page-link active" : "page-link"} onClick={() => setPageId(page)}>
                {prefixZero(page)}
              </a>
            </li>
          ))}
          <li className={`page-item ${pageId === pageCount || limit * pageId >= countCalculation ? "disabled" : ""}`}>
            <button className="page-link" onClick={nextPageHandler} disabled={limit * pageId >= countCalculation}>
              {svg.pageNext}
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};
export const redirectPath = {
  home: alias?.length ? alias : "/",
  aboutUs: alias?.length ? alias + "/about-us" : "/about-us",
  contactUs: alias?.length ? alias + "/contact-us" : "/contact-us",
  terms: alias?.length ? alias + "/terms-and-conditions" : "/terms-and-conditions",
  privacy: alias?.length ? alias + "/privacy-policy" : "/privacy-policy",
};

export const staticPgLogo = () => {
  return (
    <div className="text-center page-header">
      <a href={redirectPath?.home} className="d-inline-block">
        <img src={Logo} width={158} height={160} className="object-fit-contain headerLogo img-fluid" alt="Logo" />
      </a>
    </div>
  );
};

// Close Icon Image
export const CloseIcon = () => <img src={Close} alt="close" />;

type Image = {
  _id: string;
  image: string;
  thumb: string;
  user: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  is_active: number;
};

type Props = {
  images: Image[];
  defaultImageId: string; // Default image ID for when no images are provided
};

export const ImageGallery: React.FC<Props> = ({ images, defaultImageId }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<any | null>(null);
  const [selectedImageState, setSelectedImageState] = useState<Image | null>(null);

  // Set the default image based on defaultImageId or use the first image
  const defaultImage = images?.length > 0 ? images.find((image) => image._id === defaultImageId) || images[0] : null;
  // Set the default selected image state
  if (!selectedImageState && defaultImage) {
    setSelectedImageState(defaultImage);
  }

  // Handle Thumbnail Click
  const handleThumbnailClick = (image: Image) => {
    setSelectedImageState(image);
  };

  return (
    <div>
      {/* Main Swiper */}
      <Swiper
        loop={true}
        spaceBetween={0}
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper2 mb-3"
      >
        {selectedImageState ? (
          [selectedImageState].map((image) => (
            <SwiperSlide key={image._id}>
              <div className="mainSliderBox position-relative overflow-hidden rounded-3">
                <img
                  src={`${BACKEND_DOMAIN}/${image?.image}`}
                  alt="Main Image"
                  className="position-absolute start-0 top-0 w-100 h-100 object-fit-cover"
                />
              </div>
            </SwiperSlide>
          ))
        ) : (
          <SwiperSlide key={"noImageFound"}>
            <div className="mainSliderBox position-relative overflow-hidden rounded-3">
              <img
                src={`${BACKEND_DOMAIN}/${"public/common/profile.svg"}`}
                alt="Main Image"
                className="position-absolute start-0 top-0 w-100 h-100 object-fit-cover"
              />
            </div>
          </SwiperSlide>
        )}
      </Swiper>

      {/* Thumbnail Swiper */}
      <Swiper
        onSwiper={setThumbsSwiper}
        loop={true}
        spaceBetween={7}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper"
      >
        {images?.length > 0 &&
          images.map((image) => (
            <SwiperSlide key={image._id} onClick={() => handleThumbnailClick(image)}>
              <img
                src={`${BACKEND_DOMAIN}/${image.thumb}`}
                alt="Thumbnail"
                style={{
                  width: "75px",
                  height: "90px",
                  objectFit: "cover",
                  borderRadius: "4px",
                  border: image._id === selectedImageState?._id ? "2px solid #000" : "none", // Highlight selected thumbnail
                }}
              />
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
};

interface DashboardFieldIF {
  columnClass: string;
  className: string;
  path: string;
  svg: ReactNode;
  label: string;
  value?: number | string;
  color?: string;
}
export const DashboardField: React.FC<DashboardFieldIF> = ({
  columnClass,
  className,
  path,
  svg,
  label,
  value,
  color,
}) => {
  return (
    <>
      <div className={`col-xl col-md-4 ${columnClass}`}>
        <NavLink className="card dash__card border-0 rounded-3 shadow h-100" to={path}>
          <div className="card-body d-flex flex-column justify-content-between">
            <div className={"d-flex align-items-center mb-2 " + className}>
              {svg}
              <span className={"fs-6 fw-semibold " + className} style={{ color: color ?? "black" }}>
                {label}
              </span>
            </div>
            <h3 className="fw-bolder fs-36 text-black mb-0">{value ?? 0}</h3>
          </div>
        </NavLink>
      </div>
    </>
  );
};

export const FullScreenLoader = ({ text }: any) => {
  return (
    <div className="d-flex justify-content-center align-items-center h-100">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">{text ?? ""}</span>
      </div>
    </div>
  );
};
export const HalfScreenLoader = ({ text }: any) => {
  return (
    <div className="d-flex justify-content-center align-items-center height-for-half-loader">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">{text ?? ""}</span>
      </div>
    </div>
  );
};

export const HalfScreenLoader2 = ({ text }: any) => {
  return (
    <div className="d-flex justify-content-center align-items-center height-for-half-loader2">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">{text ?? ""}</span>
      </div>
    </div>
  );
};

export const AddSearchSelect = ({
  data,
  value,
  placeholder,
  hanldeOnChange,
  hanldeAddNewValue,
  addButtonName,
  inputRef,
  isAddOn,
  selectRef,
  loading = false,
  isAllowClear = true,
  getLoading = false,
  isDisabled = false,
}: any) => {
  const [isSearchValue, setIsSearchValue] = useState("");
  const [isAddNewValue, setIsAddNewValue] = useState(false);
  const [addebleName, setAddebleName] = useState("");
  const [isError, setIsError] = useState(false);
  const searchInputRef = useRef<InputRef>(null);
  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsSearchValue(e.target.value);
  };

  const onPositionNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsError(false);
    setAddebleName(e?.target?.value?.trim() ? e.target.value : "");
  };

  return (
    <Field name="state">
      {({ field, form }: any) => (
        <Select
          {...field}
          style={{ width: 300 }}
          placeholder="Select"
          disabled={isDisabled ? true : false}
          allowClear={isAllowClear ? true : false}
          ref={selectRef || null}
          suffixIcon={svg.dropdownDownArrow}
          onDropdownVisibleChange={(open) => {
            if (open) {
              setTimeout(() => {
                searchInputRef.current?.focus();
              }, 100);
            }
          }}
          dropdownRender={(menu) => (
            <>
              <Input
                placeholder="Search items"
                value={isSearchValue}
                onChange={onSearch}
                ref={searchInputRef}
                style={{
                  margin: "8px",
                  width: "calc(100% - 16px)",
                }}
                allowClear
              />
              {getLoading ? (
                <div className="d-flex justify-content-center my-2">
                  <Spin size="small" />
                </div>
              ) : data?.length ? (
                menu
              ) : (
                <div className="d-flex justify-content-center text-muted py-2">No items found</div>
              )}
              <Divider style={{ margin: "8px 0" }} />
              <Space
                style={{
                  padding: "0 8px 4px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {isAddNewValue ? (
                  <>
                    <Input
                      placeholder={placeholder ?? "Please enter value"}
                      ref={inputRef}
                      value={addebleName}
                      onChange={onPositionNameChange}
                      onKeyDown={(e) => e.stopPropagation()}
                      style={isError ? { borderColor: "red" } : {}}
                    />
                    <Button
                      type="text"
                      icon={svg?.closeIcon}
                      disabled={loading}
                      onClick={() => {
                        if (!loading) {
                          setIsAddNewValue(false);
                          setIsError(false);
                        }
                      }}
                    />
                    {loading ? (
                      <BtnLoader color="#000" />
                    ) : (
                      <Button
                        type="text"
                        icon={svg?.rightIcon}
                        onClick={(e) => {
                          if (addebleName) {
                            hanldeAddNewValue(e, addebleName, setIsAddNewValue, setAddebleName);
                          } else {
                            setIsError(true);
                          }
                        }}
                      />
                    )}
                  </>
                ) : (
                  <div
                    className="d-flex justify-content-center text-secondary cursor-pointer"
                    onClick={() => setIsAddNewValue(true)}
                  >
                    + {addButtonName ?? ""}
                  </div>
                )}
              </Space>
            </>
          )}
          // notFoundContent={
          //   getLoading ? (
          //     <div className="d-flex justify-content-center">
          //       <Spin size="small" />
          //     </div>
          //   ) : null
          // }
          value={value || null} // Formik value binding
          onChange={hanldeOnChange}
          options={data
            ?.filter((elem: any) => elem?.name?.toLowerCase()?.includes(isSearchValue.toLowerCase()))
            ?.map((item: any) => ({
              label: item?.name,
              value: item?._id, // or item?._id based on your API
            }))}
        />
      )}
    </Field>
  );
};

export const SearchSelect = ({
  data,
  value,
  hanldeOnChange,
  fieldName,
  disabled,
  selectRef,
  isAllowClear = true,
  getLoading = false,
  searchPlaceHolder = "",
  placeholder = "",
}: any) => {
  const [isSearchValue, setIsSearchValue] = useState("");
  const searchInputRef = useRef<InputRef>(null);
  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsSearchValue(e.target.value);
  };
  return (
    <Field name={fieldName}>
      {({ field, form }: any) => (
        <Select
          {...field}
          style={{ width: 300 }}
          allowClear={isAllowClear ? true : false}
          ref={selectRef || null}
          placeholder={placeholder ? placeholder : "Select"}
          // notFoundContent={
          //   getLoading ? (
          //     <div className="d-flex justify-content-center">
          //       <Spin size="small" />
          //     </div>
          //   ) : null
          // }
          onDropdownVisibleChange={(open) => {
            if (open) {
              setTimeout(() => {
                searchInputRef.current?.focus();
              }, 100);
            }
          }}
          disabled={disabled ? true : false}
          suffixIcon={svg.dropdownDownArrow}
          dropdownRender={(menu) => (
            <>
              <Input
                placeholder={searchPlaceHolder ? searchPlaceHolder : "Search items"}
                value={isSearchValue}
                ref={searchInputRef}
                onChange={onSearch}
                style={{
                  margin: "8px",
                  width: "calc(100% - 16px)",
                }}
                allowClear
              />
              {getLoading ? (
                <div className="d-flex justify-content-center my-2">
                  <Spin size="small" />
                </div>
              ) : data?.length ? (
                menu
              ) : (
                <div className="d-flex justify-content-center text-muted py-2">No items found</div>
              )}
            </>
          )}
          value={value || null} // Formik value binding
          onChange={hanldeOnChange}
          options={data
            ?.filter((elem: any) => elem?.name?.toLowerCase().includes(isSearchValue.toLowerCase()))
            .map((item: any) => ({
              label: item?.name,
              value: item?._id, // or item?._id based on your API
            }))}
        />
      )}
    </Field>
  );
};

export const NoDataMessage = ({ text, icon, color }: any) => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center text-center h-100 py-5">
      {icon ? <span className="svg-60 d-inline-block mb-4">{icon}</span> : ""}
      <p className={`"fs-6 ${color ? color : "text-black"} mb-0"`}>{text ?? ""}</p>
    </div>
  );
};

export const NoAccessMessageComponent = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center text-center h-100">
      <p className="fs-6 text-black mt-4 ">You do not have access to this page.</p>
    </div>
  );
};

interface ButtonWithLoaderProps {
  isLoading: boolean;
  onClick?: () => void; // Make onClick optional if you only use type="button"
  disabled?: boolean;
  children: React.ReactNode; // To accept button label or any child elements
  className?: string; // Optional class names for styling
  type?: "button" | "submit" | "reset"; // Add type prop
}

export const ButtonWithLoader: React.FC<ButtonWithLoaderProps> = ({
  isLoading,
  onClick,
  disabled = false,
  children,
  className = "btn btn-primary",
  type = "button",
}) => {
  return (
    <button
      type={type}
      className={`${className} ${isLoading ? "disabled" : ""}`}
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <>
          {children} <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </>
      ) : (
        children
      )}
    </button>
  );
};

export const RedStar = () => <span style={{ color: "red" }}>*</span>;

export const InvalidCsvDataModal: React.FC<any> = ({
  open,
  onClose,
  InsertData = [],
  InvalidData = [],
  AlreadyExist = [],
}) => {
  // Dynamically generate columns based on keys in first row
  const hiddenKeys = ["_id", "business", "deleted_at", "created_at", "updated_at", "__v"];

  const generateColumns = (data: any[]) => {
    if (data.length === 0) return [];

    const allKeys = Object.keys(data[0]).filter((key) => !hiddenKeys.includes(key));

    // Move 'error' and 'errors' to the front
    const sortedKeys = [
      ...["error", "errors"].filter((k) => allKeys.includes(k)), // add if present
      ...allKeys.filter((k) => !["error", "errors"].includes(k)), // rest
    ];

    return sortedKeys.map((key) => ({
      title: key.charAt(0).toUpperCase() + key.slice(1),
      dataIndex: key,
      key,
      render: (value: any) => {
        // Format timestamps
        if (typeof value === "string" && moment(value, moment.ISO_8601, true).isValid()) {
          return value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "-";
        }

        // Format error arrays
        if (key === "errors" && Array.isArray(value)) {
          if (value.length === 0) return "-";
          return (
            <ul>
              {value.map((err, idx) => (
                <li key={idx}>
                  <Tooltip title={err.message}>
                    <span className="text-danger">{err.context?.label || err.path?.join(".") || "-"}</span>
                  </Tooltip>
                </li>
              ))}
            </ul>
          );
        }

        if (key === "error") {
          return <span className="text-danger">{value ? value : "-"}</span>;
        }

        if (typeof value === "boolean") {
          return value ? "Yes" : "No";
        }

        // if (typeof value === "object" && value !== null) {
        //   if (Array.isArray(value) && value.length === 0) return "-";
        //   const stringified = JSON.stringify(value);
        //   return stringified === "{}" ? "-" : stringified;
        // }

        return value || value == 0 ? value : "-";
      },
    }));
  };

  const columns: ColumnsType<any> = useMemo(() => generateColumns(InvalidData), [InvalidData]);
  const columns2: ColumnsType<any> = useMemo(() => generateColumns(AlreadyExist), [AlreadyExist]);
  const columns3: ColumnsType<any> = useMemo(() => generateColumns(InsertData), [InsertData]);

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: <button className="btn btn-lg btn-outline-secondary">Success Data {`(${InsertData?.length})`}</button>,
      children: (
        <>
          {InsertData?.length > 0 ? (
            <div className="card border-0 shadow rounded-4">
              <div className="card-body p-3">
                <Table
                  rowKey="id"
                  dataSource={InsertData}
                  columns={columns3}
                  scroll={{ x: true }}
                  // pagination={{ pageSize: 5 }}
                  className="custom-table"
                />
              </div>
            </div>
          ) : (
            <div className="">
              <NoDataMessage text={"No data"} icon={svg?.csvNodataIcon} />
            </div>
          )}
        </>
      ),
    },
    {
      key: "2",
      label: <button className="btn btn-lg btn-outline-secondary">Invalid Data {`(${InvalidData?.length})`}</button>,
      children: (
        <>
          {InvalidData?.length > 0 ? (
            <div className="card border-0 shadow rounded-4">
              <div className="card-body p-3">
                <Table
                  rowKey="id"
                  dataSource={InvalidData}
                  columns={columns}
                  scroll={{ x: true }}
                  // pagination={{ pageSize: 5 }}
                  className="custom-table"
                />
              </div>
            </div>
          ) : (
            <NoDataMessage text={"No data"} icon={svg?.csvNodataIcon} />
          )}
        </>
      ),
    },
    {
      key: "3",
      label: <button className="btn btn-lg btn-outline-secondary">Already Exists {`(${AlreadyExist?.length})`}</button>,
      children: (
        <>
          {AlreadyExist?.length > 0 ? (
            <div className="card border-0 shadow rounded-4">
              <div className="card-body p-3">
                <Table
                  rowKey="id"
                  dataSource={AlreadyExist}
                  columns={columns2}
                  scroll={{ x: true }}
                  // pagination={{ pageSize: 5 }}
                  className="custom-table"
                />
              </div>
            </div>
          ) : (
            <NoDataMessage text={"No data"} icon={svg?.csvNodataIcon} />
          )}
        </>
      ),
    },
  ];

  const onChange = (key: string) => {};

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={<div className="modal-header border-bottom pb-2 fw-bold fs-4">CSV Upload Data Information</div>}
      width={"100%"}
    >
      <div className="flex-fill static-data-container">
        <Tabs
          defaultActiveKey={InsertData?.length > 0 ? "1" : InvalidData?.length > 0 ? "2" : "3"}
          items={items}
          className="ant-tabs-container"
          onChange={onChange}
        />
      </div>
    </Modal>
  );
};
